export type ProjectIndexNavState = {
  indexRect?: {
    top: number;
    left: number;
  };
};

export const PROJECT_INDEX_HOLD_MS = 500;
export const PROJECT_INDEX_MOVE_MS = 700;
